import type { Transition, Variants } from "motion/react";

/** Loader fade-out. Never delay session work to finish this. */
export const APP_BOOTSTRAP_EXIT_DURATION_S = 0.12;
/** Resolved surface fade-in. Opacity only — no y, so scroll/sticky trees stay untransformed. */
export const APP_BOOTSTRAP_ENTER_DURATION_S = 0.16;
/** Workspace reveal after an organization entry or switch hold. Runs after readiness, never before. */
export const APP_WORKSPACE_REVEAL_DURATION_S = 0.3;

const EASE = [0.22, 1, 0.36, 1] as const;

/** Hidden under the loader while an organization entry or switch is held. */
const COVERED = { opacity: 0, transition: { duration: 0 } };

const INSTANT: Transition = { duration: 0 };

export function appBootstrapExitMotion(reduceMotion: boolean): Transition {
  return {
    duration: reduceMotion ? 0 : APP_BOOTSTRAP_EXIT_DURATION_S,
    ease: EASE,
  };
}

export function appBootstrapEnterMotion(reduceMotion: boolean): {
  variants: Variants;
  transition: Transition;
} {
  if (reduceMotion) {
    return {
      variants: {
        initial: { opacity: 1 },
        animate: { opacity: 1 },
        covered: COVERED,
      },
      transition: INSTANT,
    };
  }

  return {
    variants: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      covered: COVERED,
    },
    transition: {
      duration: APP_BOOTSTRAP_ENTER_DURATION_S,
      ease: EASE,
    },
  };
}

/**
 * Transition for the surface leaving `covered`. A 404/403 or a failed session
 * is shown at once, as before; a ready workspace fades in.
 */
export function appWorkspaceRevealMotion(input: {
  reduceMotion: boolean;
  immediate: boolean;
}): Transition {
  if (input.reduceMotion || input.immediate) return INSTANT;
  return { duration: APP_WORKSPACE_REVEAL_DURATION_S, ease: "easeOut" };
}
